import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { DropdownComponent, InputComponent } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TeethHighlightComponent } from '../teeth-highlight';
import { TreatmentPlanDialogDate, TreatmentPlanDialogService } from './treatment-plan-dialog.service';
import { TreatmentCardComponent } from './treatment-card';
import { TreatmentPlanDialogDataVM } from './treatment-plan-dialog.vm';

@Component({
  selector: 'lib-treatment-plan-dialog',
  imports: [
    InputComponent,
    TranslateModule,
    TeethHighlightComponent,
    SvgIconComponent,
    TreatmentCardComponent,
    LottieComponent,
    DropdownComponent,
    CurrencyPipe,
    CommonModule,
  ],
  templateUrl: './treatment-plan-dialog.component.html',
  styleUrl: './treatment-plan-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TreatmentPlanDialogService],
})
export class TreatmentPlanDialogComponent implements OnInit {
  private readonly dialogRef = inject(DialogRef);
  private readonly screenService = inject(TreatmentPlanDialogService);
  private readonly dialogData: TreatmentPlanDialogDataVM = inject(DIALOG_DATA);

  protected readonly highlightedTeeth = computed(() => this.screenService.viewModel().highlightedTeeth);
  protected readonly treatmentList = computed(() => this.screenService.viewModel().treatmentList);
  protected readonly numberOfselectedTreatments = computed(() => this.screenService.viewModel().numberOfSelectedTreatments);
  protected readonly treatmentsCostSum = computed(() => this.screenService.viewModel().treatmentsCostSum);
  protected readonly providers = computed(() => this.screenService.viewModel().providers);
  protected readonly isLoading = computed(() => this.screenService.viewModel().isLoading);
  protected readonly searchQuery = computed(() => this.screenService.viewModel().searchQuery);
  protected readonly dateOption = computed(() => this.screenService.viewModel().dateOption);
  protected readonly TreatmentPlanDialogDate = TreatmentPlanDialogDate;

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  public ngOnInit(): void {
    this.screenService.setSiteId(this.dialogData.siteId);
    this.screenService.setPatientId(this.dialogData.patientId);
    this.screenService.init();
  }

  protected onCloseClick(): void {
    this.dialogRef.close();
  }

  protected onReviewClick(): void {
    this.screenService.openReviewDialog(this.dialogRef);
  }

  protected onSearchQueryChange(query: string): void {
    this.screenService.updateSearchQuery(query);
  }

  protected onDateOptionChange(option: TreatmentPlanDialogDate | TreatmentPlanDialogDate[] | null): void {
    this.screenService.onDateOptionChange(option);
  }

  protected onTreatmentProviderChange(index: number, providerId: string): void {
    this.screenService.updateTreatmentProvider({ index, providerId });
  }

  protected onTreatmentToggle(index: number): void {
    this.screenService.toggleTreatmentSelection(index);
  }
}
